import React, { FC, useState } from "react";
import "./HeaderPage.scss";
import { Col, Container, Row } from "react-bootstrap";

interface HeaderPageProps {
  title: string;
  subtitle: string;
  maxLength?: number;
  isMarginTop?: boolean;
}

const HeaderPage: FC<HeaderPageProps> = ({
  title,
  subtitle,
  maxLength = 270,
  isMarginTop = true,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  return (
    <div
      className="HeaderPage"
      data-testid="HeaderPage"
      style={{
        background: `url(${process.env.PUBLIC_URL}/assets/img/background-wrapper-2.png) no-repeat center center`,
        backgroundSize: "cover",
        marginTop: isMarginTop ? "64px" : 0,
      }}
    >
      <Container className="py-4">
        <Row className="justify-content-center">
          <Col md={10}>
            <div className="greeting-wrapper d-flex flex-column justify-content-center">
              <h1 className="text-secondary mb-0">{title}</h1>
              {subtitle.length <= maxLength ? (
                <p className="text-white mb-0">{subtitle}</p>
              ) : (
                <p className="text-white mb-0">
                  {isExpanded ? subtitle : subtitle.slice(0, maxLength) + "..."}{" "}
                  <button
                    onClick={toggleExpanded}
                    style={{
                      color: "var(--secondary)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    {isExpanded ? " ver menos" : " ver mais"}
                  </button>
                </p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeaderPage;
